import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CompanyLegacyModule } from '@core/components/legacy-input/search-one/company/company.module';
import { LocationGroupLegacyModule } from '@core/components/legacy-input/search-one/location-group/location-group.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterLocationsComponent } from './filter-locations.component';

@NgModule({
  declarations: [
    FilterLocationsComponent
  ],
  imports: [
    CompanyLegacyModule,
    LocationGroupLegacyModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatDividerModule,
    MatSelectModule,
    TranslateModule,
    MatOptionModule,
    MatInputModule,
    CommonModule,
  ],
  exports: [
    FilterLocationsComponent
  ]
})
export class FilterLocationsModule { }
